import React, { useEffect, useState } from "react";
import { Alert, Form } from "../../../layout";
import { Button, InputPass } from "../../../controls";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { Model, UseForm } from "../../../hooks";
import { PassValidation } from "../../../utils";
import { action, controller, Server } from "../../../api/Server";
import { ToFormData } from "../../../hooks/Method";

const ResetPasswordForm = ({ setShowForm, userId }) => {
  const { t } = useTranslation();
  const { PassResetMdl } = Model();
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const {
    values,
    setValues,
    errors,
    passValid,
    setErrors,
    handleInpPass,
    resetFormControls,
  } = UseForm(PassResetMdl);

  useEffect(() => {
    setValues((j) => ({ ...j, userId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const handleClose = () => {
    resetFormControls();
    setShowForm(false);
  };

  const validateForm = () => {
    let temp = {};
    temp.userId = values.userId !== "" ? "" : t("userIdNotFound");
    temp.newPassword = values.newPassword !== "" ? "" : t("passwordIsRequired");
    temp.confirmPassword =
      values.confirmPassword !== ""
        ? values.confirmPassword === values.newPassword
          ? ""
          : t("passwordAndConfirmPasswordDidNotMatch")
        : t("confirmPassIsRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      Server(controller.User + action.ResetPassword).post(
        ToFormData(values),
        (res) => {
          setLoading(false);
          if (res?.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("success"),
              subTitle: res.msg,
              onClick: () => handleClose(),
            });
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: t("error"),
              subTitle: res.msg,
            });
        }
      );
    }
  };

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={2} className="p-15 pt-30">
          <Grid item xs={12}>
            <div className="tx-center">
              <span className="fs-22 tx-upp fw-5 ml-5 gray-color">
                {t("resetPassword")}
              </span>
              <div className="bs-bottom mx-w-80 m-auto mt-10 mb-30" />
            </div>
          </Grid>
          {errors.userId && (
            <Grid item xs={12}>
              <span className="error-color pl-5">* {errors.userId} Jihad</span>
            </Grid>
          )}
          <Grid item xs={12}>
            <InputPass
              label={t("newPassword")}
              name="newPassword"
              value={values.newPassword}
              onChange={handleInpPass}
              error={errors.newPassword}
              className="input-primary w-100pr"
            />
            {values.newPassword && (
              <PassValidation
                {...{ newPassword: values.newPassword, passValid }}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <InputPass
              label={t("confirmPassword")}
              name="confirmPassword"
              value={values.confirmPassword}
              onChange={(e) => handleInpPass(e, true)}
              error={
                errors.confirmPassword !== "" &&
                values.newPassword !== "" &&
                !passValid.match &&
                values.confirmPassword !== ""
                  ? t("passwordAndConfirmPasswordNotMatch")
                  : errors.confirmPassword
              }
              className="input-primary w-100pr"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              onClick={handleClose}
              className="error-color bg-errorSM w-100pr"
              size="large"
            >
              {t("cancel")}
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              type="submit"
              loading={loading}
              size="large"
              className="w-100pr"
            >
              {t("submit")}
            </Button>
          </Grid>
        </Grid>
      </Form>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default ResetPasswordForm;
